// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ebf5578e","977":"002546ef"}[chunkId] + ".chunk.js";
};